export default {
  en: {
    ValuationWaitingIndexScene: {
      title: 'Waiting Valuation',
    },
  },
};
